import React, { Component } from 'react'
import { Formik, Form, Field } from 'formik';
import { Input, Textarea, Select } from '../../../ui/forms/formik';
import { contact_us_schema } from './contact_us_schema';
import { Button } from 'react-bootstrap';
import Recaptcha from 'react-recaptcha';
import { Helmet } from 'react-helmet';

export default class ContactForm extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
             recaptchaVerified: undefined
        }
    }
    
    render() {
        const initialValues = {
            name: '',
            email: '',
            phone: '',
            company: '',
            profession: '',
            help: '',
            message: ''
        }
        return (
            <div className="contact-form">
                <Formik
                    initialValues={initialValues}
                    validationSchema={contact_us_schema}
                    onSubmit={(values, actions) => {
                        console.log(values);
                    }}
                    validateOnMount
                >{(props) => (
                    <Form className="formik">
                        <Field
                            name="name"
                            placeholder="Your Name"
                            component={Input}
                            className="input input-white input-xl"
                        />
                        <Field
                            name="email"
                            placeholder="Your Email"
                            component={Input}
                            className="input input-white input-xl"
                        />
                        <Field
                            name="phone"
                            placeholder="Your Phone"
                            component={Input}
                            className="input input-white input-xl"
                        />
                        <Field
                            name="company"
                            placeholder="Your Company/Agency/Club"
                            component={Input}
                            className="input input-white input-xl"
                        />
                        <Field
                            name="profession"
                            placeholder="Your Profession"
                            component={Select}
                            className="select select-white select-xl"
                            options={[]}
                        />
                        <Field
                            name="help"
                            placeholder="Where we can help you?"
                            component={Select}
                            className="select select-white select-xl"
                            options={[]}
                        />
                        <Field
                            name="message"
                            placeholder="Your Message"
                            component={Textarea}
                            rows="6"
                            className="input input-white input-xl"
                        />
                        {this.renderRecaptcha()}
                        <div className="buttons-container">
                            <Button
                                variant="secondary"
                                className="sm btn-lg"
                                onClick={() => this.handleCancel()}
                            >Cancel</Button>
                            <Button
                                variant="primary"
                                className="sm btn-lg"
                                disabled={!(props.isValid && props.dirty) || !this.state.recaptchaVerified}
                                type="submit"
                            >Send</Button>
                        </div>
                    </Form>
                )}
                </Formik>
            </div>
        )
    }

    renderRecaptcha = () => {
        return (
            <div className="recaptcha-container">
                <Helmet>
                    <script src="https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit" async defer></script>
                </Helmet>
                <Recaptcha
                    sitekey="6LfTY_kUAAAAABLy_Q8UraDzCLRPHdmr85Pm-_JW"
                    render="explicit"
                    expiredCallback={this.handleRecaptchaVerify}
                    onloadCallback={this.handleRecaptchaVerify}
                    verifyCallback={this.handleRecaptchaVerify}
                />
            </div>
        )
    }

    handleCancel = () => {
        
    }

    handleRecaptchaVerify = verified => {
        this.setState({ recaptchaVerified: verified })
    }
}
